import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav'

const VendorConfigLayout = () => {
  const navList = useNav();
  let { vendorsConfigBottom, vendorsConfigTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={vendorsConfigBottom} topTabs={vendorsConfigTopHeader} />
      <Outlet />
    </div>
  )
}

export default VendorConfigLayout
